import { ACTIVE_OUTLET, RESTAURANT_CONFIG } from "../types/config";

const initialState = {
  restaurantConfig: null,
  activeOutlet: null,
};

const configReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case RESTAURANT_CONFIG:
      return { ...state, restaurantConfig: payload };
    case ACTIVE_OUTLET:
      return { ...state, activeOutlet: payload };
    default:
      return state;
  }
};

export default configReducer;
